export default function createEnvironments(baseUrl: string, userManagementUrl?: string, prodUserManagementUrl?: string) {
  const pumpSevice = '/api/pump';

  const createUrl = (urlPath: string, urlPrefix: string = baseUrl) => {
    if (!urlPrefix.endsWith('/')) {
      urlPrefix = urlPrefix + '/';
    }

    return (
      urlPrefix +
      urlPath
        .split('/')
        .filter((el) => el.length > 0)
        .join('/')
    );
  };

  return {
    production: false,
    getAllMachines: {
      get: createUrl(pumpSevice + '/machines/dropdown'),
      getfields: createUrl(pumpSevice + '/machines/fields/dropdown'),
      fetch: createUrl(pumpSevice + '/machines/module-fields'),
      postMachineSelector: createUrl(pumpSevice + '/operating-point/machine-selector/calculation'),
      postMachineFinder: createUrl(pumpSevice + '/operating-point/machine-finder/calculation'),
      postPerformanceCurve: createUrl(pumpSevice + '/performance-curve/by-machine-name'),
      postEvacuation: createUrl(pumpSevice + '/evacuation-time/calculate'),
      postInjectionSuctionSide: createUrl(pumpSevice + '/injection-suction/compute'),
      postTemperatureCalculation: createUrl(pumpSevice + '/operating-point/temperature-calculation'),
      postGasMixtureOther: createUrl(pumpSevice + '/gas-mixture/other/compute'),
    },
    units: {
      formulas: createUrl(pumpSevice + '/unit/formula'),
    },
    login: {
      apiEndpoint: userManagementUrl + '/api/v3/login',
      logout: userManagementUrl + '/api/v3/logout',
    },
    user: {
      recoverPassword: userManagementUrl + '/api/v2/user/productselection/resetpassword',
      resetPassword: userManagementUrl + '/api/v2/user/{username}/resetpassword/{token}',
      checkResetPasswordToken: userManagementUrl + '/api/v2/user/check/{username}/{token}',
    },
  };
}
